import React from "react";

import { RestrictedComponent } from "../../common/RestrictedComponent";
import {
    BillingUsageLabel,
    IBillingUsageLabelProps,
} from "./BillingUsageLabel";

export function RestrictedBillingUsageLabel(props: IBillingUsageLabelProps) {
    return (
        <RestrictedComponent
            resource="billing"
            requiredAccess="administrator"
            requiredFeature="billing"
        >
            <BillingUsageLabel {...props} />
        </RestrictedComponent>
    );
}
